define('all/player/documents-uploader',['jquery', 'all/textKey', 'all/dialog', 'all/jquery/jquery.fileupload', 'all/jquery/jquery.iframe-transport'], function ($, textKey, dialog) {
	'use strict';

	// Beware: very specific to legacy upload.jsp

	var FILE_VALIDATION_NAME = 'uploadfile22';
	var TYPE_VALIDATION_NAME = 'filetype';
	var OTHER_TYPE_VALIDATION_NAME = 'other-type';
	var OTHER_REASON_VALIDATION_NAME = 'other-reason';

	var MAX_SIZE_BYTES = 2097152; // 2097152 = 2MB

	var ALLOWED_EXTENSIONS = ['pdf', 'gif', 'jpg', 'jpeg', 'bmp', 'png', 'tif', 'tiff'];

	var MESSAGES = {
		VALIDATION_ERROR_FILE_TO_LARGE: 'File is too big',
		VALIDATION_ERROR_WRONG_FORMAT: 'Not allowed file type',
		SYSTEM_ERROR_GENERAL: 'Server error',
		ERROR_HEADER: 'Hmmm...',
		HEADER_PANEL_CONF_UPLOADED_DOC: 'Upload successful',
		MESSAGE_CONF_UPLOADED_DOC: 'Documents uploaded!'
	};

	function updateMessages(messages) {
		$.extend(MESSAGES, messages);
	}

	textKey.readTextValues(Object.keys(MESSAGES), updateMessages);

	var documentsUploader = {};

	var selectedFileData;
	var selectedFile;

	function fileAdded(e, data) {
		var $filename = $('#choosed-filename');
		$filename.hide();
		if (data.files.length === 1) {
			selectedFile = data.files[0];
			var verifiedOk = verifyFile(selectedFile);
			if (!verifiedOk) {
				return false;
			}
			selectedFileData = data;
			$('#filename-name').text(selectedFile.name);
			$filename.fadeIn();
		}
	}

	function uploadFile() {
		var verifiedCheckBoxes = verifyCheckBoxes();
		var verifiedOtherType = verifyOtherTypeText();
		var verifiedComment = verifyComment();
		var verifiedFile = verifyFile(selectedFile);
		if (verifiedCheckBoxes && verifiedComment && verifiedOtherType && verifiedFile) {
			displayLoader();
			selectedFileData.submit();
		}
	}

	function fileUploadDone(e, data) {
		hideLoader();
		console.log(data);

		if(data.result.error) {
			console.log(data.result.message);
			showError(data.result.statusCode);
			return;
		}

		var dialogData = {
			title: MESSAGES.HEADER_PANEL_CONF_UPLOADED_DOC,
			message: MESSAGES.MESSAGE_CONF_UPLOADED_DOC
		};

		dialog.load('info', dialogData, $.noop, reload);
	}

	function fileUploadFail(e, data) {
		hideLoader();

		var jqXHR = data.jqXHR;
		console.error('Upload failed:', jqXHR.statusCode(), jqXHR.responseText);

		showError(jqXHR.statusCode());
	}

	function showError(statusCode) {
		var dialogData = {};
		dialogData.title = MESSAGES.ERROR_HEADER;
		switch (statusCode) {
			case 413:
				dialogData.message = MESSAGES.VALIDATION_ERROR_FILE_TO_LARGE;
				break;
			case 400:
				dialogData.message = MESSAGES.VALIDATION_ERROR_WRONG_FORMAT;
				break;
			default:
				dialogData.message = MESSAGES.SYSTEM_ERROR_GENERAL;
				break;

		}
		dialog.load('error', dialogData, $.noop, reload);
	}

	function verifyFile(file) {
		var verifiedOk = verifyFileExtension(file.name) && verifyFileSize(file.size);
		if (verifiedOk) {
			window.showSymbol(FILE_VALIDATION_NAME, 'fieldstatus-ok');
		} else {
			window.showSymbol(FILE_VALIDATION_NAME, 'fieldstatus-error');
		}

		return verifiedOk;
	}

	function verifyFileSize(size) {
		var verifiedOk = size <= MAX_SIZE_BYTES;
		if (!verifiedOk) {
			var message = MESSAGES.VALIDATION_ERROR_FILE_TO_LARGE;
			document.getElementById('uploadfile22-error').innerHTML = '<div class="tale"></div><div class="body">' + message + '</div>';
		}
		return  verifiedOk;
	}

	function verifyFileExtension(name) {
		var index = name.lastIndexOf('.');
		var extension = name.substr(index + 1, name.length).toLowerCase();
		var verifiedOk = ALLOWED_EXTENSIONS.indexOf(extension) >= 0;
		if (!verifiedOk) {
			var message = MESSAGES.VALIDATION_ERROR_WRONG_FORMAT;
			document.getElementById('uploadfile22-error').innerHTML = '<div class="tale"></div><div class="body">' + message + '</div>';
		}
		return  verifiedOk;
	}

	function displayLoader() {
		var loaderHTML = document.getElementById('loadingUpPopup').innerHTML;
		window.top.displayShade(loaderHTML);
	}

	function hideLoader() {
		window.top.hideShade();
	}

	function verifyCheckBoxes() {
		var $checkBoxes = $('#type-dl').find('input[type="checkbox"]:checked');
		var verifiedOk = $checkBoxes.length > 0;
		if (verifiedOk) {
			window.showSymbol(TYPE_VALIDATION_NAME, 'fieldstatus-ok');
		} else {
			window.showSymbol(TYPE_VALIDATION_NAME, 'fieldstatus-error');
		}
		return verifiedOk;
	}

	function verifyOtherTypeText() {
		var $otherType = $('#other-type');
		var otherTypeText = $otherType.val();
		var $otherTypeCheckbox = $('#filetype6');
		var otherTypeShown = $otherTypeCheckbox.prop('checked');
		var verifiedOk = !otherTypeShown || otherTypeText.length >= 2 && otherTypeText.length <= 50;
		if (verifiedOk) {
			window.showSymbol(OTHER_TYPE_VALIDATION_NAME, 'fieldstatus-ok');
		} else {
			window.showSymbol(OTHER_TYPE_VALIDATION_NAME, 'fieldstatus-error');
		}
		return verifiedOk;
	}

	function verifyComment() {
		var $comment = $('#other-reason');
		var otherTypeText = $comment.val();
		var length = otherTypeText.length;
		if (length === 0) {
			return true;
		}
		var verifiedOk = length <= 100;
		if (verifiedOk) {
			window.showSymbol(OTHER_REASON_VALIDATION_NAME, 'fieldstatus-ok');
		} else {
			window.showSymbol(OTHER_REASON_VALIDATION_NAME, 'fieldstatus-error');
		}
		return verifiedOk;
	}

	function reload() {
		window.location.reload();
	}

	documentsUploader.initForm = function ($form) {
		$form.find('.fileinput-button').fileupload({
			dataType: 'json',
			add: fileAdded,
			done: fileUploadDone,
			fail: fileUploadFail
		});

		var $checkBoxes = $form.find('#type-dl input[type="checkbox"]');
		$checkBoxes.change(verifyCheckBoxes);

		var $otherTypeContainer = $form.find('#other-type-dl');
		$form.find('#filetype6').click(function () {
			var showOther = $(this).prop('checked');
			$otherTypeContainer.toggle(showOther);
		});

		$otherTypeContainer.find('#other-type').keyup(verifyOtherTypeText);

		var $otherReason = $form.find('#other-reason').keyup(verifyComment);
		$otherReason.focus(function () {
			window.showMessage(OTHER_REASON_VALIDATION_NAME);
		});

		var $submitButton = $form.find('#submit-dl button');
		$submitButton.click(uploadFile);

	};

    documentsUploader.init = function () {
        var $form = $('#upload-form').find('form');
        documentsUploader.initForm($form);
    };

	// export legacy, TODO fix, see UploadListTag.java
	window.removeDocument = removeDocument;

	return documentsUploader;

	// TODO: legacy for UploadListTag.java
	// removes selected document for a player (document is still visible in backend)
	function removeDocument(docId, pId, uploadPageRemoveDocumentText) {

		var OkCancel = function () {
			this.ok = function () {
				$.post('/pp?flow=removeUploadedDocument&docId=' + docId + '&pId=' + pId).success(function () {
					reload();
				});
			};
			this.cancel = $.noop;
		};

		var okc = new OkCancel();
		okc.run = window;

		var x = document.getElementById('removeDocConfirmPopUp');

		window.top.showOkCancelPanel(uploadPageRemoveDocumentText, x.innerHTML, okc, null);
	}


});
